module.exports = __webpack_public_path__ + "img/capa-azul.1d861145.jpg";